<template>
    <div class="variation-overlay" style="z-index: 50000">
        <h1 class="mb-3">Generating your asset</h1>
        <div style="width: 55px; height: 55px; position: relative;" class="mb-3" v-if="variation && variation.coobo_library_link_priority_queue && variation.coobo_library_link_priority_queue.status != 'error'">
            <div class="loading" style="top: 0; left: 0">
                <div class="effect-1 effects"></div>
                <div class="effect-2 effects"></div>
                <div class="effect-3 effects"></div>
            </div>
        </div>
        <div class="mb-2" v-if="variation && variation.coobo_library_link_priority_queue && variation.coobo_library_link_priority_queue.status == 'error'">
            Queue id: {{ variation.coobo_library_link_priority_queue._id }}
        </div>
        <div class="variation-overlay-status mb-2">
            Status: {{ variation && variation.coobo_library_link_priority_queue ? variation.coobo_library_link_priority_queue.status : 'in_queue' }}
        </div>
        <div class="mb-2" v-if="variation">
            Variation id: {{ variation._id }}
        </div>
        <div class="mb-2" v-if="variation && variation.coobo_library_link_priority_queue">
            Timestamp: {{ getDateFormat(variation.coobo_library_link_priority_queue.updatedAt) }}
        </div>
        <div class="process-asset-pre" v-if="variation && variation.coobo_library_link_priority_queue && variation.coobo_library_link_priority_queue.status === 'error' && variation.coobo_library_link_priority_queue.data">
          <pre>
            {{ variation.coobo_library_link_priority_queue.data.generationFailed === 'error' ? 'Try to export to GLB and process again. We are using Blender to compress the asset and make it coobo friendly.' : variation.coobo_library_link_priority_queue.data }}
          </pre>
        </div>
        <vs-button class="shadow-lg variation-refresh-btn mb-6" type="gradient" @click="getVariantData">
            <i class="material-icons notranslate"> refresh </i> Refresh status
        </vs-button>
        <vs-button class="shadow-lg variation-refresh-btn" type="gradient" @click="close"
                   style="margin-top: 2px">Cancel
        </vs-button>
    </div>
</template>

<script>

export default {
    components: {

    },
    props: {
      getVariantData: {
        type: Function,
        default: () => {}
      },
      cancel: {
        type: Function,
        default: () => {}
      },
      variation: {
          type: Object,
          default: null
      }
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    destroyed() {

    },
    watch: {

    },
    methods: {
      getDateFormat(date) {
        let d = new Date(date);
        return (d.getMonth() + 1) + "/" + d.getDate() + "/" + d.getFullYear() + " " +
          d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
      },
      close() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Warning close popup`,
          text: 'Your asset generation progress will be lost. Are you sure?',
          accept: () => {this.cancel()}
        })
      },
    }
}
</script>

